
import { defineComponent } from 'vue'

export default defineComponent(
{
    name: 'CookieBanner',
    data()
    {
        return {
            showCookieBanner: false
        }
    },
    methods:
    {
        acceptCookies()
        {
            this.showCookieBanner = false
        },
        rejectCookies()
        {
            this.showCookieBanner = false
        }
    }
})
